import type { AbstractControl } from '@angular/forms';
import type { PackageUnitSystem } from './package-types.config';

/**
 * Weight unit i18n key for the active measurement system.
 */
export function customerWeightUnitLabelKey(unitSystem: PackageUnitSystem): string {
  return unitSystem === 'imperial'
    ? 'createShipment.packageStep.details.weightUnitLb'
    : 'createShipment.packageStep.details.weightUnitKg';
}

/**
 * Dimension unit i18n key for the active measurement system.
 */
export function customerDimensionUnitLabelKey(unitSystem: PackageUnitSystem): string {
  return unitSystem === 'imperial'
    ? 'createShipment.packageStep.details.dimUnitIn'
    : 'createShipment.packageStep.details.dimUnitCm';
}

/**
 * True when a piece-field control should show an error (invalid and touched or after Add/Save).
 */
export function customerPieceFieldHasError(
  control: AbstractControl,
  showValidationErrors: boolean,
): boolean {
  if (!control.invalid) {
    return false;
  }

  return control.touched || showValidationErrors;
}

/**
 * Maps field validation errors to the inline message key.
 * Max → Exceeds limit; required/empty → Required; other validator failures → Invalid.
 */
export function customerPieceFieldErrorKey(control: AbstractControl): string {
  if (control.hasError('max')) {
    return 'createShipment.packageStep.details.exceedsLimit';
  }

  if (control.hasError('required')) {
    return 'createShipment.packageStep.details.inlineRequired';
  }

  return 'createShipment.packageStep.details.inlineInvalid';
}

/**
 * Marks a piece field touched on blur so validation can surface without changing the value.
 * Length, width, and height keep up to two decimal places as entered.
 */
export function blurCustomerPieceField(control: AbstractControl, _controlName: string): void {
  control.markAsTouched();
}
